import { ActionTypes } from '../actions';

const initialState = {
  all: [],
  current: {},
};

const PagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_PAGES:
      return { all: action.payload, current: state.current };
    case ActionTypes.FETCH_PAGE:
      return { all: state.all, current: action.payload };
    case ActionTypes.DELETE_PAGE:
      return { all: state.all, current: {} };
    default:
      return state;
  }
};

export default PagesReducer;
